"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addDTMScriptToDOM(url) {
    if (typeof document === 'undefined') {
        return;
    }
    var scriptNode = document.createElement('script');
    scriptNode.src = url;
    scriptNode.async = true;
    document.head.appendChild(scriptNode);
}
function AdobeAnalytics(options) {
    if (typeof window !== 'undefined') {
        window[options.dataLayerName] = options.defaultDataLayer;
    }
    var isAnalyticsDisabled = options.disableAnalytics;
    if (!isAnalyticsDisabled) {
        addDTMScriptToDOM(options.scriptUrl);
    }
    var dataLayerExists = function () {
        return typeof window !== 'undefined' &&
            typeof window[options.dataLayerName] !== 'undefined' &&
            typeof window._satellite !== 'undefined';
    };
    var fireTrackingEvent = function (eventName, payload) {
        if (!dataLayerExists() || isAnalyticsDisabled) {
            return;
        }
        window._satellite.track(eventName, payload);
    };
    return {
        fireTrackingEvent: fireTrackingEvent,
    };
}
exports.default = AdobeAnalytics;
//# sourceMappingURL=AdobeAnalytics.js.map